module.exports = __webpack_public_path__ + "img/bjs.c526b917.png";